import React, { useState, useEffect } from 'react';
import Header from '../../component/layout/Header';
import Footer from '../../component/layout/Footer';
import Page from '../../component/utility/Page';
import DataTable from 'react-data-table-component';
import { custTableStyles } from '../../style/color';
import axios from 'axios';
import { mainurl, imgurl } from '../../Mainurl';
import AddEventTopic from '../../component/utility/master/AddEventTopic';

import { Row, Col, Card, CardHeader, CardBody, FormGroup, Input, Label, InputGroup, InputGroupText, Spinner, Button } from 'reactstrap';
import { FaEye, FaEdit, FaPlusCircle, FaClipboardList } from 'react-icons/fa';

const EventTopicMaster = () => {
    const [mode, setMode] = useState(1);
    const [loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState([]);

    useEffect(() => {
        
    }, [])

    const get_topic_list = () => {
        setTableData('');
        let postData = [{ "org_id": sessionStorage.getItem('org_id'), "user_id": sessionStorage.getItem('user_id'), "lang_id": 1 }];
        axios({
            method: 'post',
            url: mainurl + 'Master/box_event_subject_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {

                    return (
                        {
                            sl: index + 1,
                            name: row.topic_desc,
                            name_h: row.topic_desc_ne,
                            status: <div className='text-primary'>Active</div>,
                        }
                    )
                });

                setTableData(list);
            })
            .catch(error => {
                setLoading(false);
                //let notify = notification({ message: "User list not Found! Try Again", type: 'error' });
                //notify();
            });
    }


    const back_handler = () => {
        setMode(1);
        get_topic_list();
    }
    return (
        <>
            <Header />
            <Page title='Event Topic' breadcrumbs='Home / Event Topic'>
                {mode === 1 &&
                    <Row className='p-3'>
                        <Col xs={12}>
                            <Card className='mb-3' color="primary" outline>
                                <CardBody>
                                    <Row>
                                        <Col md={2}>
                                            <Button className='text-white' color='primary' size="sm" block onClick={get_topic_list}> <FaClipboardList className='me-1' size={20} /> Get Topic List</Button>
                                        </Col>
                                        <Col md={3}>
                                            <Button className='text-white' color='primary' size="sm" block onClick={() => setMode(2)}>
                                                <FaPlusCircle className='me-1' size={20} />
                                                Add New Event Topic
                                            </Button>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col md={{ offset: 2, order: 2, size: 8 }}>
                            <Card className='' color="primary" outline>
                                <CardBody>
                                    <DataTable
                                        title=""
                                        customStyles={custTableStyles}
                                        columns={[
                                            {
                                                name: '#',
                                                selector: row => row.sl,
                                                sortable: true,
                                                width: '80px'
                                            },
                                            {
                                                name: 'Topic Name',
                                                selector: row => row.name,
                                                sortable: false,
                                            },
                                            {
                                                name: 'Topic Name Hindi',
                                                selector: row => row.name_h,
                                                sortable: false,
                                            },
                                            {
                                                name: 'Status',
                                                selector: row => row.status,
                                                sortable: false,
                                            },
                                        ]}
                                        data={tableData}
                                        highlightOnHover
                                        progressPending={loading}
                                    />
                                </CardBody>
                            </Card>
                        </Col>

                    </Row>
                }
                {mode === 2 &&
                    <Col xs={12} className='p-3'>
                        <AddEventTopic back={() => back_handler()} />
                    </Col>
                }
            </Page>
            <Footer />

        </>
    )
}

export default EventTopicMaster;